module.exports = __webpack_public_path__ + "img/zhuanji-logo.f9df8e70.png";